<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-sm p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						강의 목차 가져오기
					</h2>
					<a class="close" @click="config.show = false">&times;</a>
				</div>
				<!-- //end .modal-header -->
				<div class="modal-body p-10 clearfix">
					<div class="send-search-box m-t-15 clearfix">
						<div class="search-box full-width">
							<input id="search" class="form-control round full-width m-b-0" type="text" placeholder="강의 목차명으로 검색하세요." autocomplete="off" v-model="keyword">
							<label for="search">검색</label>
						</div>
					</div>
					<!-- //end .send-search-box -->
					<p class="m-t-15 m-b-0 clearfix">
						<span class="text-bold text-darkgray pull-left">검색결과</span>
						<span class="pull-right">총 {{curriculums.filter(c=>c.name.indexOf(keyword)>=0).length}}건</span>
					</p>
					<div class="list-box">
						<table class="full-width table-condensed table-hover m-t-0 m-b-0">
							<tbody>
								<tr v-for="(curriculum, idx) in curriculums.filter(c=>c.name.indexOf(keyword)>=0)" :item="curriculum" :index="idx" :key="'curriculum-original-list-'+idx+hash(curriculum)">
									<td>{{curriculum.name}}</td>
									<td>총 {{curriculum.lesList.length}}개 차시</td>
									<td class="text-right">
										<button class="btn-sm bg-deepblue text-white round" @click="select(curriculum)">추가</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<p class="m-t-15 m-b-0 clearfix">
						<span class="text-bold text-darkgray pull-left">추가된 강의목록</span>
					</p>
					<div class="list-box">
						<table class="full-width table-condensed table-hover m-t-0 m-b-0">
							<tbody>
								<tr v-for="(curriculum, idx) in selected" :item="curriculum" :index="idx" :key="'curriculum-selected-list-'+idx+hash(curriculum)">
									<td>{{curriculum.name}}</td>
									<td class="text-right">
										<a class="del text-center" @click="remove(curriculum)">삭제</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<!-- //end .modal-body -->
				<div class="modal-footer p-10">
					<button class="btn bg-deepblue text-white full-width m-t-30 round" type="button" @click="copy">만들기</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import server from '../statics/server.js'
import axios from 'axios'

export default {
	name: "ModalCurriculumCompile",

	default: function() {
		return {
			name: this.name,
			show: false,
			lecId: 0
		}
	},

	mounted: function() {
		axios.post(server.addr()+server.api.CURRICULUM, {}).then( (response) => {
			this.curriculums = response.data.list;
		})
	},

	data: function() {
		return  {
			keyword: "",
			curriculums: [],
			selected: []
		}
	},

	props: {
		config: Object
	},

	methods: {
		select: function(curriculum) {
			this.selected.push(curriculum);
		},
		remove: function(curriculum) {
			this.selected.splice(this.selected.indexOf(curriculum), 1);
		},
		copy: function() {
			if(this.selected.length==0) return;
			this.selected = JSON.parse(JSON.stringify(this.selected));
			this.selected.forEach((c) => {
				c.curriculumId = "";
				c.lecId = this.$route.params.lecId;
				if(c.curriculumExamMappingList) c.curriculumExamMappingList.forEach((m)=>delete m.curriculumId);
				if(c.curriculumSurveyMappingList) c.curriculumSurveyMappingList.forEach((m)=>delete m.curriculumId);
				if(c.lesList) c.lesList.forEach((lesGrp) => {
					lesGrp.curriculumId = "";
					lesGrp.lesId = "";
					if(lesGrp.lesList) lesGrp.lesList.forEach((les) => {
						les.lesId = "";
						les.curriculumId = "";
						les.parentsId = "";
					});
				});
			});
			axios.put(server.addr()+"/curriculum", this.selected).then( (response) => {
				this.$emit("CurriculumSelected", response.data.list);
				this.config.show = false;

			})
		}
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>